import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateAccountNameMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateManagedAccountTradingNameInput;
}>;

export type UpdateAccountNameMutationResult = { __typename?: 'Mutation' } & {
  updateManagedAccountTradingName?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateManagedAccountTradingNamePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountNameDocument = /*#__PURE__*/ gql`
  mutation updateAccountName($input: UpdateManagedAccountTradingNameInput!) {
    updateManagedAccountTradingName(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateAccountNameMutation__
 *
 * To run a mutation, you first call `useUpdateAccountNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountNameMutation, { data, loading, error }] = useUpdateAccountNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountNameMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAccountNameMutationResult, UpdateAccountNameMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateAccountNameMutationResult, UpdateAccountNameMutationVariables>(
    UpdateAccountNameDocument,
    options
  );
}
export type UpdateAccountNameMutationHookResult = ReturnType<typeof useUpdateAccountNameMutation>;
